// Average spectrum chart (log frequency) for source vs. the two needle simulations.
export interface SpectrumLine {
  db: Float32Array;
  color: string;
  label: string;
  dashed?: boolean;
}

export function drawSpectrum(canvas: HTMLCanvasElement, lines: SpectrumLine[], fs: number, marks: { hz: number; color: string; label: string }[] = []) {
  const dpr = window.devicePixelRatio || 1;
  const cssW = canvas.clientWidth, cssH = canvas.clientHeight || 190;
  canvas.width = cssW * dpr;
  canvas.height = cssH * dpr;
  const ctx = canvas.getContext("2d")!;
  ctx.scale(dpr, dpr);
  const L = 34, R = 8, T = 8, B = 20;
  const w = cssW - L - R, h = cssH - T - B;
  const f0 = 20, f1 = fs / 2, dbMin = -90;
  const fx = (f: number) => L + (Math.log(f / f0) / Math.log(f1 / f0)) * w;
  const dy = (db: number) => T + (Math.max(dbMin, db) / dbMin) * h;
  ctx.fillStyle = "#0e1013";
  ctx.fillRect(0, 0, cssW, cssH);
  ctx.font = "10px system-ui";
  ctx.strokeStyle = "#252a31";
  ctx.fillStyle = "#6f7782";
  ctx.lineWidth = 1;
  for (const f of [50, 100, 200, 500, 1000, 2000, 5000, 10000, 20000]) {
    if (f > f1) continue;
    const x = Math.round(fx(f)) + 0.5;
    ctx.beginPath(); ctx.moveTo(x, T); ctx.lineTo(x, T + h); ctx.stroke();
    ctx.fillText(f >= 1000 ? `${f / 1000}k` : `${f}`, x - 8, cssH - 6);
  }
  for (let db = 0; db >= dbMin; db -= 30) {
    const y = Math.round(dy(db)) + 0.5;
    ctx.beginPath(); ctx.moveTo(L, y); ctx.lineTo(L + w, y); ctx.stroke();
    ctx.fillText(`${db}`, 6, y + 3);
  }
  for (const m of marks) {
    if (!(m.hz > f0 && m.hz < f1)) continue;
    const x = fx(m.hz);
    ctx.setLineDash([3, 3]);
    ctx.strokeStyle = m.color;
    ctx.beginPath(); ctx.moveTo(x, T); ctx.lineTo(x, T + h); ctx.stroke();
    ctx.setLineDash([]);
  }
  for (const ln of lines) {
    const n = ln.db.length;
    ctx.strokeStyle = ln.color;
    ctx.lineWidth = 1.3;
    ctx.setLineDash(ln.dashed ? [4, 3] : []);
    ctx.beginPath();
    let started = false;
    for (let k = 1; k < n; k++) {
      const f = (k / (n - 1)) * f1;
      if (f < f0) continue;
      const x = fx(f), y = dy(ln.db[k]);
      if (!started) { ctx.moveTo(x, y); started = true; } else ctx.lineTo(x, y);
    }
    ctx.stroke();
  }
  ctx.setLineDash([]);
  let lx = L + 6;
  for (const ln of lines) {
    ctx.fillStyle = ln.color;
    ctx.fillRect(lx, T + 4, 10, 3);
    ctx.fillStyle = "#c8cdd4";
    ctx.fillText(ln.label, lx + 14, T + 9);
    lx += ctx.measureText(ln.label).width + 28;
  }
}
